import {
  Validators,
  AbstractControl,
  ValidatorFn,
  ValidationErrors,
} from '@angular/forms';

import { isPresent } from '../utils/is-present';

export const mobile: ValidatorFn = (
  control: AbstractControl
): ValidationErrors => {
  if (isPresent(Validators.required(control))) {
    return null;
  }

  const v: string = control.value;
  return /^(07[\d]{9})$/g.test(v) ? null : { mobile: true };
};
